// Inline SVG flags. Emoji flags render as plain letters ("CZ") on Windows,
// so the language switcher draws its own. Colors are the official flag colors.
const FLAGS = {
  cs: (
    <>
      <rect width="60" height="20" fill="#fff" />
      <rect y="20" width="60" height="20" fill="#d7141a" />
      <path d="M0 0 30 20 0 40z" fill="#11457e" />
    </>
  ),
  en: (
    <>
      <rect width="60" height="40" fill="#012169" />
      <path d="M0 0 60 40M60 0 0 40" stroke="#fff" strokeWidth="8" />
      <path d="M0 0 60 40M60 0 0 40" stroke="#c8102e" strokeWidth="3" />
      <path d="M30 0v40M0 20h60" stroke="#fff" strokeWidth="12" />
      <path d="M30 0v40M0 20h60" stroke="#c8102e" strokeWidth="7" />
    </>
  ),
  pl: (
    <>
      <rect width="60" height="20" fill="#fff" />
      <rect y="20" width="60" height="20" fill="#dc143c" />
    </>
  ),
  de: (
    <>
      <rect width="60" height="14" fill="#000" />
      <rect y="13" width="60" height="14" fill="#dd0000" />
      <rect y="26" width="60" height="14" fill="#ffce00" />
    </>
  ),
};

export const FlagIcon = ({ code, className }) => (
  <svg viewBox="0 0 60 40" className={className} aria-hidden="true" focusable="false">
    {FLAGS[code]}
  </svg>
);
